export default function (context) {
    // Prevent disabled tabs to be clicked in modals.
    $('.modal .nav li:not(.disabled) a', context).click(function (e) {
        e.preventDefault();
        $(this).tab('show');
    });

    $('input[type="checkbox"].disabled', context).on('click', (e) => {
        e.preventDefault();
        return false
    })
}
